import React from 'react';
import Svg, { Path } from 'react-native-svg';
var SVGComponent = function SVGComponent(props) {
  var style = props.style;
  return /*#__PURE__*/React.createElement(Svg, {
    width: "25",
    height: "24",
    viewBox: "0 0 25 24",
    fill: "none",
    style: style
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M11.8839 16.1768L19.0303 9.03033L17.9697 7.96967L11 14.9393L7.03033 10.9697L5.96967 12.0303L10.1161 16.1768C10.6043 16.6649 11.3957 16.6649 11.8839 16.1768Z",
    fill: "#30B566"
  }), /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 23C18.5751 23 23.5 18.0751 23.5 12C23.5 5.92487 18.5751 1 12.5 1C6.42487 1 1.5 5.92487 1.5 12C1.5 18.0751 6.42487 23 12.5 23ZM22 12C22 17.2467 17.7467 21.5 12.5 21.5C7.25329 21.5 3 17.2467 3 12C3 6.75329 7.25329 2.5 12.5 2.5C17.7467 2.5 22 6.75329 22 12Z",
    fill: "#30B566"
  }));
};
export default SVGComponent;